(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["echo-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('echo-brand-carousel')) {
    customElements.define('echo-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.echo-brands__track');
        if (!this.track.children.length) return;
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.rotate !== 'true' || this.motion.matches || !!window.Shopify?.designMode;
        this.visible = false;
        this.hovered = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('.echo-brands__controls').hidden = false;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          this.pause();
          this.move(Number(button.dataset.direction));
        }, options));
        this.toggle?.addEventListener('pointerdown', () => { this.toggleWasPaused = this.paused; }, options);
        this.toggle?.addEventListener('click', () => {
          this.paused = !(this.toggleWasPaused ?? this.paused);
          this.toggleWasPaused = undefined;
          this.update();
        }, options);
        this.track.addEventListener('pointerdown', () => this.pause(), options);
        this.track.addEventListener('keydown', () => this.pause(), options);
        this.addEventListener('focusin', () => this.pause(), options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.update(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.echo-brands__item');
          if (item && this.contains(item)) {
            this.pause();
            this.track.scrollTo({ left: item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft, behavior: 'instant' });
          }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold: 0.25 });
        this.observer.observe(this);
        this.update();
      }
      pause() { this.paused = true; this.update(); }
      update() {
        clearInterval(this.timer);
        if (this.toggle) this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        if (!this.paused && this.visible && !this.hovered && !document.hidden) {
          this.timer = setInterval(() => this.move(1), Number(this.dataset.delay) || 5000);
        }
      }
      move(direction) {
        const step = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max <= 1) return;
        let left = this.track.scrollLeft + step * direction;
        if (direction > 0 && this.track.scrollLeft >= max - 2) left = 0;
        if (direction < 0 && this.track.scrollLeft <= 2) left = max;
        this.track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
